/**
 * Utilidades compartidas para subida de imagenes.
 *
 * El backend convierte HEIC/HEIF a WebP. El navegador no decodifica HEIC,
 * asi que para esos formatos NO se genera preview local: los componentes
 * muestran un mensaje en su lugar.
 */

export function isHeicOrHeif(file: File | null | undefined): boolean {
    if (!file) {
        return false;
    }

    const type = (file.type || '').toLowerCase();
    const name = (file.name || '').toLowerCase();

    return (
        type === 'image/heic' ||
        type === 'image/heif' ||
        type === 'image/heic-sequence' ||
        type === 'image/heif-sequence' ||
        /\.(heic|heif)$/.test(name)
    );
}

/**
 * Genera el preview de una imagen como DataURL.
 * Para HEIC/HEIF no lee el archivo (el navegador no lo decodifica) y avisa
 * por `onUnsupported`; en error de lectura tambien llama a `onUnsupported`.
 */
export function readImagePreview(
    file: File,
    onPreview: (value: string | ArrayBuffer) => void,
    onUnsupported?: () => void
): void {
    if (isHeicOrHeif(file)) {
        if (onUnsupported) {
            onUnsupported();
        }
        return;
    }

    const reader = new FileReader();
    reader.onload = () => onPreview(reader.result as string | ArrayBuffer);
    reader.onerror = () => {
        if (onUnsupported) {
            onUnsupported();
        }
    };
    reader.readAsDataURL(file);
}
